import { HttpClient } from 'shared/libs/http';
import {
   CreateJobDto,
   CreateJobEmptyResponse,
   CreateJobResponse,
   JobApplyCheckUserDto,
   JobApplyCheckUserResponse,
   JobApplyCodeDto,
   JobApplyCodeResponse,
   JobApplyDonwloadCvResponse,
   JobApplyGetFileList,
   JobApplySentJobApplyDto,
   JobApplySentJobApplyResponse,
   JobListingResponse,
   JobLocationSearchDto,
   JobLocationSearchResponse,
   JobSubCategoryResponse,
} from './types';
import { FormService } from 'shared/libs/form';
export class JobApiService {
   public static async getJobs(dto: {
      guid: string;
      userId: string;
      seo_slug: string;
      positionFrom: number;
      category_slug?: string;
      subcategory_slug?: string;
      job_city?: string;
      keyword?: string;
   }) {
      return await HttpClient.post<JobListingResponse>('/job/listing', dto);
   }

   public static async getSubCategories(categoryId: number) {
      return await HttpClient.post<JobSubCategoryResponse>(
         '/categories/getSubCategory/' + categoryId,
         null
      );
   }

   public static async jobApplyCheckUser(dto: JobApplyCheckUserDto) {
      return await HttpClient.post<JobApplyCheckUserResponse>('/jobApply/checkUser', dto);
   }

   public static async jobApplyCode(dto: JobApplyCodeDto) {
      return await HttpClient.post<JobApplyCodeResponse>('/jobApply/code', dto);
   }

   public static async jobApplyGetFileList() {
      return await HttpClient.get<JobApplyGetFileList>('/jobApply/getFileList');
   }

   public static async localitySearch(dto: JobLocationSearchDto) {
      return await HttpClient.post<JobLocationSearchResponse>('/locality/search', dto);
   }

   public static async jobApplyDonwloadCv({ id }: { id: string | number }) {
      return await HttpClient.get<JobApplyDonwloadCvResponse>('/jobApply/downloadFile/' + id, {
         responseType: 'blob',
      });
   }

   public static async jobApplySentJobApply(dto: JobApplySentJobApplyDto) {
      return await HttpClient.post<JobApplySentJobApplyResponse>(
         '/jobApply/sentJobApply',
         FormService.toFormData(dto)
      );
   }

   public static async jobCreateJob<TDto extends CreateJobDto | null>(dto: TDto) {
      return await HttpClient.post<TDto extends null ? CreateJobEmptyResponse : CreateJobResponse>(
         '/job/createJob',
         dto
      );
   }

   public static async loadJob<TDto extends { slugId: string }>(dto: TDto) {
      return await HttpClient.post<CreateJobEmptyResponse>('/job/createJob/' + dto?.slugId, null);
   }

   public static async loadEditableJob<TDto extends { slugId: string }>(dto: TDto) {
      return await HttpClient.post<CreateJobEmptyResponse>('/job/edit/' + dto?.slugId, null);
   }

   public static async editJob(dto: { slugId: string; job: CreateJobDto }) {
      return await HttpClient.post<CreateJobResponse>('/job/edit/' + dto.slugId, dto.job);
   }
}
